module.exports = __webpack_public_path__ + "img/br3gj.5a89f38c.png";